<template>
  <!-- 客服工作台 -->
  <div class="customer-service-work-bench">
    <div class="work-bench-left">
      <div class="work-bench-left-top">
        <div class="filter-area">
          <div class="selectDateL">
            <Icon class="caption-icon" type="md-calendar" />
            <span class="caption">待办订单</span>
            <div class="weekMonth">
              <span
                v-for="(item,index) in selectedData"
                :key="index"
                class="orange"
                :class="item.selectedFlag ? 'selected' : ''"
                @click="selected(index)"
              >{{item.title}}</span>
            </div>
            <div class="selectTime">
              <DatePicker :transfer="true" type="daterange" v-model="dateArr" :options="selectDate" placement="bottom-end" style="width: 200px;" @on-change="selectTimeChange"></DatePicker>
            </div>
          </div>
          <div class="selectDateR">
            <Select v-model="warehouse" multiple multipleType @on-change="onchange" @on-open-change="timeOpenChange" filterable chooseAll>
              <Option v-for="(item,index) in option" :key="index" :value="item.id">{{item.name}}</Option>
            </Select>
          </div>
        </div>
        <div class="manage-list">
          <div class="Loading1">
            <ul class="manage-left">
              <li v-for="(item,index) in statisticalList" :key="index">
                <span @click="jumpOrderClick(item.key, item.value)">{{item.value}}</span>
                <a class="manage-name" :title="item.prompt">{{item.name}}</a>
              </li>
            </ul>
            <div class="fromLoading" v-show="Loading1">
              <Spin></Spin>
            </div>
          </div>
          <div class="Loading2">
            <ul class="manage-right">
              <li v-for="(item,index) in statisticalList2" :key="index">
                <span @click="jumpReturnClick(item.key, item.value)">{{item.value}}</span>
                <a class="manage-name" :title="item.prompt">{{item.name}}</a>
              </li>
            </ul>
            <div class="fromLoading" v-show="Loading2">
              <Spin></Spin>
            </div>
          </div>
        </div>
      </div>
      <div class="work-bench-echart">
        <div style="display: flex; justify-content: space-between;">
          <div>
            <Icon class="overview-icon" type="logo-buffer" />
            <span class="overview-title">经营概览</span>
          </div>
          <div class="refreshDate">
            <Icon style="vertical-align: baseline;" type="md-alarm" />
            <span>更新时间：{{newTime}}</span>
            <span style="margin-left: 10px; color: #3C8DBC; cursor: pointer;" @click="getList">刷新</span>
          </div>
        </div>
        <div id="main" style="width: 100%; height: 400px; left: -45px"></div>
        <div class="fromLoading" v-show="Loading3">
          <Spin></Spin>
        </div>
      </div>
    </div>
    <div class="work-bench-right">
      <div class="Loading4">
        <div class="bench-total totalSales">
          <div class="totalSales-top">
            <span class="total-title">销售总额</span>
            <span class="total-btn">{{dateTime}}</span>
          </div>
          <div class="total-amt sales-pg">
            <p>￥<span class="amt-color">{{scaleAmt.SALE_TOT_AMT}}</span></p>
          </div>
          <div class="total-percentage sales-pg">
            <span>{{scaleAmt.SALE_SCALE}}</span>
            <Icon v-if="orderIcon == 'up'" class="total-icon" type="ios-arrow-round-up" />
            <Icon v-if="orderIcon == 'down'" class="total-icon" type="ios-arrow-round-down" />
          </div>
        </div>
        <div class="bench-total totalRefund">
          <div class="totalSales-top">
            <span class="total-title">退款总额</span>
            <span class="total-btn btn-bule">{{dateTime}}</span>
          </div>
          <div class="total-amt refund-pg">
            <p>￥<span class="amt-color">{{scaleAmt.SALE_RETURN_TOT_AMT}}</span></p>
          </div>
          <div class="total-percentage refund-pg">
            <span>{{scaleAmt.RETURN_SCALE}}</span>
            <Icon v-if="returnIcon == 'up'" class="total-icon" type="ios-arrow-round-up" />
            <Icon v-if="returnIcon == 'down'" class="total-icon" type="ios-arrow-round-down" />
          </div>
        </div>
        <div class="fromLoading" v-show="Loading4">
          <Spin></Spin>
        </div>
      </div>
      <div class="work-bench-right-bottom">
        <info-list :info="publicInfo"></info-list>
      </div>
    </div>
    <div class="fromLoading" v-show="isShowFromLoading">
      <Spin></Spin>
    </div>
  </div>
</template>
<script>



import axios from "axios";


import infoList from "commonCrumb/workBench/infoList.vue";
import publicMethods from "commonJs/publicMethods";


export default {
  data() {
    return {
      warehouse: [], // 选择的店仓
      timeArr: [], // 选择的时间
      selectValue: [],
      option: [],
      storeId: '',
      allValue: "", // 处理成字符串的全部店铺值
      selectedData: [
        {
          title: '日',
          selectedFlag: true
        },
        {
          title: '周',
          selectedFlag: false
        },
        {
          title: '月',
          selectedFlag: false
        }
      ],
      dateTime: '本日',
      selectDate: {
        shortcuts: [
          {
            text: '1 星期',
            value () {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            }
          },
          {
            text: '1 个月',
            value () {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            }
          },
          {
            text: '3 个月',
            value () {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            }
          }
        ]
      },
      dateArr: [],
      statisticalList: [
        {
          value: '0',
          key: 'PROFITS',
          name: '已发数量',
          prompt: '仓库发货后的订单数量'
        },{
          value: '0',
          key: 'AUDIT_EVENT',
          name: '未审核量',
          prompt: '待审核的订单数量'
        },{
          value: '0',
          key: 'FLYOUT_MENU',
          name: '账面缺货',
          prompt: '账面缺货的订单数量'
        },{
          value: '0',
          key: 'ACTUALLY_STOCKOUT',
          name: '实际缺货',
          prompt: '实际缺货的订单数量'
        },{
          value: '0',
          key: 'REDISTRIBUTIONS',
          name: '配货中量',
          prompt: '已经推送仓库等待发货的订单数'
        },{
          value: '0',
          key: 'AUDIT_ABNORMAL',
          name: '审核异常',
          prompt: '审核订单异常的订单数量'
        },{
          value: '0',
          key: 'WMS_FAILURE',
          name: '传WMS失败',
          prompt: '订单推送wms失败的订单数'
        },{
          value: '0',
          key: 'TAO_IS_NOT_OVER',
          name: '淘系超24h未发',
          prompt: '淘系付款后超24小时未仓库发货的订单数'
        },{
          value: '0',
          key: 'JINGDONG_NOT_OVER',
          name: '京东超24H未发',
          prompt: '京东付款后超24小时未仓库发货的订单数'
        },{
          value: '0',
          key: 'WAREHOUSE_NOT_OVER',
          name: '仓库超48H未发',
          prompt: '已经推送仓库超过48小时仓库未发货的订单数量'
        },{
          value: '0',
          key: 'WAREHOUSE_UNBILLED',
          name: '仓库超截单时间未发',
          prompt: '在截单时间前推送仓库，但仓库未发货的订单数量'
        },{
          value: '0',
          key: 'SCALP_NO_RECEIPT',
          name: '刷单20H未回单',
          prompt: '暂无提示'
        },{
          value: '0',
          key: 'TAO_IS_GOODS_ERROR',
          name: '淘系商品维护错误',
          prompt: '淘系订单转单时商品异常的订单数量'
        },{
          value: '0',
          key: 'JINGDONG_GOODS_ERROR',
          name: '京东商品维护错误',
          prompt: '京东订单转单时商品异常的订单数量'
        },{
          value: '0',
          key: 'GENERAL_MERCHANDISE_ERROR',
          name: '通用商品维护错误',
          prompt: '通用订单转单时商品异常的订单数量'
        }
      ],
      statisticalList2: [
        {
          value: '0',
          key: 'MATCH_WAREHOUSING',
          name: '待匹配入库',
          prompt: '等待退货入库的退货订单数量'
        },{
          value: '0',
          key: 'AFTER_SALES_AUDIT',
          name: '待售后审核',
          prompt: '等待售后审核的退货订单数量'
        },{
          value: '0',
          key: 'REFUNDED_NO_STORAGE',
          name: '已退款未入库',
          prompt: '已经退款成功且未入库完成的单据数量'
        },{
          value: '0',
          key: 'RETURN_TO_COMPLETE',
          name: '退货完成',
          prompt: '退货完成的退换货订单数量'
        },{
          value: '0',
          key: 'DELIVERY_BEFORE_REFUND',
          name: '发货前退款',
          prompt: '仓库发货前审核退款的订单数量'
        },{
          value: '0',
          key: 'DELIVERY_AFTER_REFUND',
          name: '发货后退款',
          prompt: '仓库发货后未回到平台，且申请退款的订单数量'
        },{
          value: '0',
          key: 'EXCHANGE_OUTBOUND_RECEIPT',
          name: '换货已出库未回单',
          prompt: '已经仓库发货未回单到平台的换货订单。'
        },{
          value: '0',
          key: 'SWAP_ORDER_DELIVERY',
          name: '换货单未发货',
          prompt: '仓库发货前的换货订单数量'
        },{
          value: '0',
          key: 'WORK_SINGULAR',
          name: '待办工单数',
          prompt: '暂无提示'
        }
      ],
      publicInfo: {
        icon: "ios-megaphone",
        size: "30",
        color: "",
        custom: "",
        title: "促销活动",
        width: "100%",
        height: "100%",
        toTable: 'PM_C_PROM_ACTI',
        name: 'customerServiceWorkbench',
        infos: []
      },

      optionEchart: {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['订单总数', '仓库未发', '缺货数量', '未审核量', '配货中量', '仓库已发', '退货数量', '待售后审核']
        },
        tooltip : {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#fd6442'
            }
          }
        },
        legend: {
          // data:['邮件营销','联盟广告','视频广告','直接访问','搜索引擎']
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: [],
          // name:'邮件营销',
          type:'line',
          stack: '总量',
          areaStyle: {},
        }],
        color: '#fd6442'
      },
      isShowFromLoading: false,
      Loading1: false,
      Loading2: false,
      Loading3: false,
      Loading4: false,
      dataType: 'day', // day => 日 week => 周 month => 月
      scaleAmt: {},
      orderIcon: 'equal',
      returnIcon: 'equal',
      newTime: '',
      ids: '',
      setTimeout: null
    };
  },
  components: {
    infoList,
  },
  methods: {
    // 获取退单统计页面数据
    queryList(time, warehouse) {
      const _this = this;
      _this.Loading2 = true;
      let fromdata = new FormData();
      let param = {
        START_DATE: time[0],
        END_DATE: time[1],
        SHOP_IDS: warehouse,
        DATA_TYPE: _this.dataType // day => 日 week => 周 month => 月
      }
      fromdata.append("param", JSON.stringify(param));
      axios({
        url: "/p/cs/workbenchInterfaceReturnOrder",
        method: "post",
        data: fromdata
      }).then(res => {
        if (res.data.code === 0) {
          const item = res.data.data;
          _this.Loading2 = false;
          _this.statisticalList2 = publicMethods.workArrHeavy(_this.statisticalList2, res.data.data); // 退单统计
        }
      });
    },
    // 获取订单统计页面数据
    queryList1(time, warehouse) {
      const _this = this;
      _this.Loading1 = true;
      let fromdata = new FormData();
      let param = {
        START_DATE: time[0],
        END_DATE: time[1],
        SHOP_IDS: warehouse,
        DATA_TYPE: _this.dataType // day => 日 week => 周 month => 月
      }
      fromdata.append("param", JSON.stringify(param));
      axios({
        url: "/p/cs/workbenchInterfaceWaitingOrder",
        method: "post",
        data: fromdata
      }).then(res => {
        if (res.data.code === 0) {
          const item = res.data.data;
          _this.Loading1 = false;
          _this.statisticalList = publicMethods.workArrHeavy(_this.statisticalList, res.data.data); // 退单统计
        }
      });
    },
    // 获取销售总额页面数据
    queryList2(time, warehouse) {
      const _this = this;
      _this.Loading3 = true;
      let fromdata = new FormData();
      let param = {
        START_DATE: time[0],
        END_DATE: time[1],
        SHOP_IDS: warehouse,
        DATA_TYPE: _this.dataType // day => 日 week => 周 month => 月
      }
      fromdata.append("param", JSON.stringify(param));
      axios({
        url: "/p/cs/workbenchInterfaceSaleOrderAmt",
        method: "post",
        data: fromdata
      }).then(res => {
        if (res.data.code === 0) {
          const item = res.data.data;
          _this.Loading3 = false;
          _this.scaleAmt = res.data.data; // 销售总额、退款总额
          if (_this.scaleAmt.SALE_SCALE.indexOf('-') == '-1') {
            if (_this.scaleAmt.SALE_SCALE == '0%') {
              _this.orderIcon = 'equal';
            } else {
              _this.orderIcon = 'up';
            }
          } else {
            _this.orderIcon = 'down';
            _this.scaleAmt.SALE_SCALE = _this.scaleAmt.SALE_SCALE.slice(1);
          }
          if (_this.scaleAmt.RETURN_SCALE.indexOf('-') == '-1') {
            if (_this.scaleAmt.RETURN_SCALE == '0%') {
              _this.returnIcon = 'equal';
            } else {
              _this.returnIcon = 'up';
            }
          } else {
            _this.returnIcon = 'down';
            _this.scaleAmt.RETURN_SCALE = _this.scaleAmt.RETURN_SCALE.slice(1);
          }
        }
      });
    },
    // 获取经营概览页面数据
    queryList3(time, warehouse) {
      const _this = this;
      _this.Loading4 = true;
      let fromdata = new FormData();
      let param = {
        START_DATE: time[0],
        END_DATE: time[1],
        SHOP_IDS: warehouse,
        DATA_TYPE: _this.dataType // day => 日 week => 周 month => 月
      }
      fromdata.append("param", JSON.stringify(param));
      axios({
        url: "/p/cs/workbenchInterfaceBusinessView",
        method: "post",
        data: fromdata
      }).then(res => {
        if (res.data.code === 0) {
          const item = res.data.data;
          _this.Loading4 = false;
          this.newTime = publicMethods.DatesTime(new Date());
          let exhartArr = [];
          item.forEach((item, index) => {
            if (item.key == 'ORDERSTOTAL') exhartArr[0] = item.value
              else if (item.key == 'WAREHOUSE_SEND') exhartArr[1] = item.value
              else if (item.key == 'STOCKOUT_NUM') exhartArr[2] = item.value
              else if (item.key == 'UNREVIEWED_NUM') exhartArr[3] = item.value
              else if (item.key == 'DISTRIBUTION_NUM') exhartArr[4] = item.value
              else if (item.key == 'WAREHOUSE_SENT') exhartArr[5] = item.value
              else if (item.key == 'RETURNS_NUM') exhartArr[6] = item.value
              else if (item.key == 'AFTER_SALES_AUDIT') exhartArr[7] = item.value
          })
          _this.optionEchart.series[0].data = exhartArr; // 经营概览
          let myChart = echarts.init(document.getElementById('main'));
          myChart.setOption(this.optionEchart);
        }
      });
    },
    // 选择时间
    selectTimeChange(val) {
      if (publicMethods.dateDiff(val[0], val[1]) > 90) {
        this.$Message.error('请选择小于3个月的时间进行查询！');
        return;
      }
      this.dataType = '';
      this.timeArr[0] = val[0] + " 00:00:00";
      this.timeArr[1] = val[1] + " 23:59:59";
      if (val[0]) {
        this.selectedData.forEach(item => item.selectedFlag = false)
        this.getList();
      } else {
        this.selected(0)
      }
    },
    // 切换日、周、月
    selected(date) {
      this.selectedData.forEach((item, index) => {
        if (date === index) item.selectedFlag = true
          else item.selectedFlag = false
      })
      let dateT = new Date();
      let mon = dateT.getMonth() + 1;
      let day = dateT.getDate();
      let myDate = dateT.getFullYear() + "-" + (mon < 10 ? "0" + mon : mon) + "-" + (day < 10 ? "0" + day : day);
      this.timeArr[1] = myDate + " 23:59:59";
      if (date === 0) { // 日
        // this.isShowFromLoading = true;
        this.dateTime = '本日';
        this.dataType = 'day';
        this.dateArr = [myDate, myDate];
        this.timeArr[0] = myDate + " 00:00:00";
        this.getList();
      } else if (date === 1) { // 周
        this.dateTime = '本周';
        this.dataType = 'week';
        this.dateArr = [publicMethods.getDateOld(7), myDate];
        this.timeArr[0] = publicMethods.getDateOld(7) + " 00:00:00";
        this.getList();
      } else if (date === 2) { // 月
        this.dateTime = '本月';
        this.dataType = 'month';
        this.dateArr = [publicMethods.getDateOld(30), myDate];
        this.timeArr[0] = publicMethods.getDateOld(30) + " 00:00:00";
        this.getList();
      }
    },

    // 跳转订单页面 param: JSON.stringify({id: 1,type:2})
    jumpOrderClick(key, total) {
      if (total == 0) return;
      let param = [];
      let label = [];
      if (key === 'PROFITS') {
        param = [
          {"type": "Select","queryName": "CP_C_SHOP_ID","value": this.warehouse.join(',')},
          {"type": "date","queryName": "SCAN_TIME","value": `${this.timeArr[0]}~${this.timeArr[1]}`},
          {"type": "Select","queryName": "ORDER_STATUS","value": '5,6'}
        ]
        this.selectID1(key, param, label);
      } else if (key === 'AUDIT_EVENT') {
        param = [
          {"type": "Select","queryName": "CP_C_SHOP_ID","value": this.warehouse.join(',')},
          {"type": "date","queryName": "PAY_TIME","value": `${this.timeArr[0]}~${this.timeArr[1]}`},
          {"type": "Select","queryName": "ORDER_STATUS","value": '1'}
        ]
        this.selectID1(key, param, label);
      } else if (key === 'FLYOUT_MENU') {
        param = [
          {"type": "Select","queryName": "CP_C_SHOP_ID","value": this.warehouse.join(',')},
          {"type": "date","queryName": "PAY_TIME","value": `${this.timeArr[0]}~${this.timeArr[1]}`},
          {"type": "Select","queryName": "ORDER_STATUS","value": '2'}
        ]
        this.selectID1(key, param, label);
      } else if (key === 'ACTUALLY_STOCKOUT') {
        this.selectID1(key);
      } else if (key === 'REDISTRIBUTIONS') {
        param = [
          {"type": "Select","queryName": "CP_C_SHOP_ID","value": this.warehouse.join(',')},
          {"type": "date","queryName": "DISTRIBUTION_TIME","value": `${this.timeArr[0]}~${this.timeArr[1]}`},
          {"type": "Select","queryName": "WMS_CANCEL_STATUS","value": "0"},
          {"type": "Select","queryName": "ORDER_STATUS","value": '4'}
        ]
        this.selectID1(key, param, label);
      } else if (key === 'AUDIT_ABNORMAL') {
        this.selectID1(key);
      } else if (key === 'WMS_FAILURE') {
        this.selectID1(key);
      } else if (key === 'TAO_IS_NOT_OVER') {
        this.selectID1(key);
      } else if (key === 'JINGDONG_NOT_OVER') {
        this.selectID1(key);
      } else if (key === 'WAREHOUSE_NOT_OVER') {
        this.selectID1(key);
      } else if (key === 'WAREHOUSE_UNBILLED') {
        this.selectID1(key);
      } else if (key === 'SCALP_NO_RECEIPT') {
        this.selectID1(key);
      } else if (key === 'TAO_IS_GOODS_ERROR') {
        this.$store.commit("TabOpen", {
          id: 24421,
          type: "table", //类型action
          name: "IP_B_TAOBAO_ORDER",
          label: "淘宝订单接口", //tab中文名
        });
      } else if (key === 'JINGDONG_GOODS_ERROR') {
        this.$store.commit("TabOpen", {
          id: 24482,
          type: "table", //类型action
          name: "IP_B_JINGDONG_ORDER",
          label: "京东订单接口", //tab中文名
        });
      } else if (key === 'GENERAL_MERCHANDISE_ERROR') {
        this.$store.commit("TabOpen", {
          id: 24534,
          type: "table", //类型action
          name: "IP_B_STANDPLAT_ORDER",
          label: "通用订单接口", //tab中文名
        });
      }
    },
    // 跳转退单页面
    jumpReturnClick(key, total) {
      if (total == 0) return;
      let param = [];
      let label = [];
      let returnParam = {};
      // 等待退货入库（20）、等待售后确认（30）、完成（50）、取消（60）
      if (key === 'MATCH_WAREHOUSING') {
        returnParam = {
          time: 'CREATIONDATE',
          startTime: this.timeArr[0],
          endTime: this.timeArr[1],
          returnStatus: ['20'],
          IS_ACTIVE: 'Y',
          shopId: this.warehouse.join(',')
        }
        this.selectID(key, returnParam);
      } else if (key === 'AFTER_SALES_AUDIT') {
        returnParam = {
          time: 'IN_TIME',
          startTime: this.timeArr[0],
          endTime: this.timeArr[1],
          returnStatus: ['30'],
          shopId: this.warehouse.join(',')
        }
        this.selectID(key, returnParam);
      } else if (key === 'REFUNDED_NO_STORAGE') {
        this.selectID(key);
      } else if (key === 'RETURN_TO_COMPLETE') {
        returnParam = {
          time: 'AUDIT_TIME',
          startTime: this.timeArr[0],
          endTime: this.timeArr[1],
          returnStatus: ['50'],
          shopId: this.warehouse.join(',')
        }
        this.selectID(key, returnParam);
      } else if (key === 'DELIVERY_BEFORE_REFUND') {
        this.selectID1(key);
      } else if (key === 'EXCHANGE_OUTBOUND_RECEIPT') {
        param = [
          {"type": "Select","queryName": "CP_C_SHOP_ID","value": this.warehouse.join(',')},
          {"type": "date","queryName": "SCAN_TIME","value": `${this.timeArr[0]}~${this.timeArr[1]}`},
          {"type": "Select","queryName": "ORDER_STATUS","value": '5'}
        ]
        label = [
          {"val": "2","text": "换","sort": 6,"key": "ORDER_TYPE"}
        ]
        this.selectID1(key, param, label);
      } else if (key === 'SWAP_ORDER_DELIVERY') {
        param = [
          {"type": "Select","queryName": "CP_C_SHOP_ID","value": this.warehouse.join(',')},
          {"type": "date","queryName": "CREATIONDATE","value": `${this.timeArr[0]}~${this.timeArr[1]}`},
          {"type": "Select","queryName": "WMS_CANCEL_STATUS","value": "0"},
          {"type": "Select","queryName": "ORDER_STATUS","value": '1,2,3,4'}
        ]
        label = [
          {"val": "2","text": "换","sort": 6,"key": "ORDER_TYPE"}
        ]
        this.selectID1(key, param, label);
      } else if (key === 'WORK_SINGULAR') {
        this.selectID1(key);
      } else if (key === 'DELIVERY_AFTER_REFUND') {
        this.selectID1(key);
      }
    },

    selectID(type, returnParam) {
      const _this = this;
      _this.isShowFromLoading = true;
      let fromdata = new FormData();
      let param = {
        START_DATE: this.timeArr[0],
        END_DATE: this.timeArr[1],
        SHOP_IDS: this.warehouse,
        DATA_TYPE: this.dataType, // day => 日 week => 周 month => 月
        TYPE: type
      }
      fromdata.append("param", JSON.stringify(param));
      axios({
        url: "/p/cs/workbenchInterface",
        method: "post",
        data: fromdata
      }).then(res => {
        if (res.data.code === 0 && res.data.data.value) {
          if (returnParam) {
            this.$store.commit("TabOpen", {
              id: 2661, //单据id
              type: "action", //类型action
              name: "returngoodList", //文件名
              label: "退换货订单", //tab中文名
              query: {
                id: 2661, //单据id
                tabTitle: "退换货订单", //tab中文名
                type: 'workID',
                returnParam: JSON.stringify(returnParam)
              }
            });
          } else {
            this.$store.commit("TabOpen", {
              id: 2661, //单据id
              type: "action", //类型action
              name: "returngoodList", //文件名
              label: "退换货订单", //tab中文名
              query: {
                id: 2661, //单据id
                tabTitle: "退换货订单", //tab中文名
                type: 'workID',
                returnParam: JSON.stringify({ID: res.data.data.value.join(',')})
              }
            });
          }
          _this.isShowFromLoading = false;
        }
      })
    },

    selectID1(type, params, labeldata) {
      const _this = this;
      _this.isShowFromLoading = true;
      let fromdata = new FormData();
      let param = {
        START_DATE: this.timeArr[0],
        END_DATE: this.timeArr[1],
        SHOP_IDS: this.warehouse,
        DATA_TYPE: this.dataType, // day => 日 week => 周 month => 月
        TYPE: type
      }
      fromdata.append("param", JSON.stringify(param));
      axios({
        url: "/p/cs/workbenchInterface",
        method: "post",
        data: fromdata
      }).then(res => {
        if (res.data.code === 0 && res.data.data.value) {
          if (params) {
            this.$store.commit("TabOpen", {
              id: 2627, //单据id
              type: "action", //类型action
              name: "orderManager", //文件名
              label: "订单管理", //tab中文名
              query: {
                id: 2627, //单据id
                tabTitle: "订单管理", //tab中文名
                type: 'workID',
                param: JSON.stringify(params),
                label: JSON.stringify(labeldata)
              }
            });
          } else {
            this.$store.commit("TabOpen", {
              id: 2627, //单据id
              type: "action", //类型action
              name: "orderManager", //文件名
              label: "订单管理", //tab中文名
              query: {
                id: 2627, //单据id
                tabTitle: "订单管理", //tab中文名
                type: 'workID',
                ID: res.data.data.value.join(',')
              }
            });
          }
          _this.isShowFromLoading = false;
        }
      })
    },

    queryStore() {
      //获取店仓数据
      let self = this;
      axios({
        // url: "/p/cs/queryShopPermissionByUser", // 因销售渠道权限730不上之后再用店铺权限接口
        // method: "get",
        url: "/p/cs/queryCpCShopByParam",
        method: "post",
        data: {}
      }).then(res => {
        if (res.data.code === 0) {
          self.option = res.data.data;
          self.storeId = self.option[0].id;
          self.warehouse.push(self.option[0].id);
          self.selected(0);
        } else {
          self.$Message.error(res.data.message);
        }
      });
    },

    //选择店仓
    onchange(val) {
      this.warehouse = val;
    },
    timeOpenChange(val) {
      if (!val) {
        if (!this.warehouse.length) this.warehouse.push(this.storeId)
        this.getList();
      }
    },
    // 获取活动列表
    getPromacti() {
      const _this = this;
      let fromdata = new FormData();
      fromdata.append("param", JSON.stringify({}));
      axios({
        url: "/p/cs/selectTopPromActi",
        method: "post",
        data: fromdata
      }).then(res => {
        if (res.data.code === 0) {
          _this.publicInfo.infos = res.data.data;
        }
      });
    },
    // 获取页面
    getList() {
      const _this = this;
      window.clearTimeout(_this.setTimeout);
      _this.setTimeout = null;
      this.queryList(this.timeArr, this.warehouse);
      this.queryList1(this.timeArr, this.warehouse);
      this.queryList2(this.timeArr, this.warehouse);
      this.queryList3(this.timeArr, this.warehouse);
      _this.setTimeout = setInterval(() => {
        this.getList();
      }, 60000 * 5);
      this.newTime = publicMethods.DatesTime(new Date());
    }
  },
  created() {},
  mounted() {
    this.queryStore();
    this.getPromacti();
  },
  beforeDestroy() {
    window.clearTimeout(this.setTimeout);
    this.setTimeout = null;
  }
};
</script>
<style lang="less">
.customer-service-work-bench {
  position: relative;
  padding: 8px 12px;
  display: flex;
  display: -webkit-flex;
  .work-bench-left {
    width: 75%;
    .work-bench-left-top {
      padding: 10px;
      background: #fafafa;
      border-radius: 10px;
    }
    .work-bench-echart {
      position: relative;
      padding: 10px;
      background: #fafafa;
      border-radius: 10px;
      margin-top: 20px;
      .fromLoading {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(255, 255, 255, 0.9);
        z-index: 1000 !important;
      }
      .overview-icon {
        color: #fd6442;
        font-size: 24px;
        vertical-align: sub;
      }
      .overview-title {
        color: #fd6442;
        margin-left: 3px;
        font-size: 18px;
        font-weight: bold;
        padding-top: 5px;
      }
      .refreshDate {
        margin: 5px 30px 0 0;
        color: #797979;
      }
    }
    .filter-area {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #eee;
      padding-bottom: 20px;
      .selectDateL {
        display: flex;
        color: #fd6442;
        font-size: 24px;
        .caption-icon {
          margin-top: 5px;
        }
        .caption {
          margin-left: 3px;
          font-size: 18px;
          font-weight: bold;
          padding-top: 7px;
        }
        .weekMonth {
          margin: 3px 28px 0 38px;
          font-size: 0;
          .orange {
            display: inline-block;
            padding: 6px 8px;
            cursor: pointer;
            border: 1px solid #eee;
            border-radius: 4px;
            font-size: 14px;
            color: #333;
          }
          .selected {
            // border-radius: 4px;
            color: #fefefe;
            background: #fd6442 !important;
          }
        }
        .selectTime {
          font-size: 14px;
          color: #333;
          margin-top: 5px;
        }
      }
      .selectDateR {
        margin-top: 5px;
        .ark-select {
          text-align: left;
          width: 200px;
        }
      }
    }
    .manage-list {
      display: flex;
      padding: 22px 0;
      .manage-left {
        width: 100%;
        li {
          position: relative;
          display: inline-block;
          width: 20%;
          text-align: center;
          margin-bottom: 15px;
          span {
            color: #fd6442;
            font-size: 22px;
            cursor: pointer;
          }
          span:hover {
            font-weight: bold;
          }
          .manage-name {
            display: block;
            font-size: 12px;
            line-height: 38px;
            color: #999;
            white-space:nowrap;
          }
        }
      }
      .manage-right {
        width: 100%;
        padding-left: 4%;
        li {
          display: inline-block;
          width: 32%;
          text-align: center;
          margin-bottom: 15px;
          span {
            color: #3C8DBC;
            font-size: 22px;
            cursor: pointer;
          }
          span:hover {
            font-weight: bold;
          }
          .manage-name {
            display: block;
            font-size: 12px;
            line-height: 38px;
            color: #999;
            white-space: nowrap;
          }
        }
      }
      .Loading1 {
        position: relative;
        width: 60%;
        .fromLoading {
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(255, 255, 255, 0.9);
          z-index: 1000 !important;
        }
      }
      .Loading2 {
        position: relative;
        width: 40%;
        .fromLoading {
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(255, 255, 255, 0.9);
          z-index: 1000 !important;
        }
      }
    }
    .chart-container {
      width: 100%;
      height: 260px;
    }
  }
  .work-bench-right {
    width: 25%;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    align-items: center;
    .bench-total {
      width: 90%;
      margin: 0 0 0 20px;
      background: #fafafa;
      padding: 10px;
      border-radius: 10px;
      .totalSales-top {
        padding-bottom: 8px;
        border-bottom: 1px solid #e4dfdf;
        display: flex;
        justify-content: space-between;
        .total-title {
          margin-left: 5px;
          line-height: 22px;
          font-size: 14px;
        }
        .total-btn {
          margin-right: 5px;
          display: inline-block;
          width: 36px;
          height: 22px;
          text-align: center;
          line-height: 22px;
          border-radius: 3px;
          color: #fff;
          background: #fd6442;
        }
        .btn-bule {
          background: #3C8DBC;
        }
      }
      .total-amt {
        font-size: 34px;
        line-height: 87px;
        text-align: left;
        .amt-color {
          color: #797979;
        }
      }
      .total-percentage {
        text-align: right;
        span {
          vertical-align: middle;
        }
        .total-icon {
          font-size: 18px;
        }
      }
      .sales-pg {
        color: #fd6442;
      }
      .refund-pg {
        color: #3C8DBC;
      }
    }
    .totalSales {
      margin-bottom: 30px;
    }
    .work-bench-right-bottom {
      width: 90%;
      height: 424px;
      margin: 20px 0 0 20px;
      background: #fafafa;
      padding: 10px;
      border-radius: 10px;
    }
    .Loading4 {
      width: 100%;
      position: relative;
      .fromLoading {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(255, 255, 255, 0.9);
        z-index: 1000 !important;
      }
    }
  }
  .selectDateL .selectTime .ark-input {
    box-sizing: border-box;
    height: 26px !important;
    line-height: 16px !important;
  }
  .fromLoading {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 1000 !important;
  }
}
</style>


